import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Mobile, NotMobile } from 'utils';

const useStyles = makeStyles((theme) => ({
        container: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "center",
            margin: "auto",
            backgroundColor: "gray",
            color: "white",
            width: "100%",
            height: "100px",
            padding: "50px 0 32px",
            fontFamily: "Lato"        
        },
        company: {
            marginBottom: "8px"
        }, 
        socialContainer: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center"
        },
        socialLink: {
            margin: "10px 7px",
        }, 
        socialIcon: {
            width: "45px",
            cursor: "pointer"
        },
        '@media (min-width: 768px)': {
            container: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 0,
                height: 63
            },
            content: {
                width: "100%",
                maxWidth: "1240px",
                margin: "auto",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            },
            company: {
                marginBottom: 0,
            },
            sectionWrapper: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
            },
            socialLink: {
                margin: "0 7px"
            },
            email: {
                marginRight: "20px",
                '&:hover': {
                    color: "black",
                    cursor: "pointer"
                }
            }
        }
    }))


export default function Footer() {
    const classes = useStyles();

    return (
        <div style={{ width: "100%" }}>
            <Mobile>
                <div className={classes.container}>
                    <div className={classes.company}>LifeShack Global, Inc.</div>
                    <div className={classes.email}>hello@lifeshack.io</div>
                </div>
            </Mobile>  
            <NotMobile>
                <div className={classes.container}>
                    <div className={classes.content}>
                        <div className={classes.company}>LifeShack Global, Inc.</div>
                        <div className={classes.sectionWrapper}>
                            <div className={classes.email}>hello@lifeshack.io</div>
                        </div>
                    </div>
                </div>            
            </NotMobile>          
        </div>
    )
}
